export const whitelist = [
    'Walton County Line Home',
    'South Walton Home',
    'North Of The Bay Home'
]